import React, { useEffect, useRef, useState } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Done, Search } from '@material-ui/icons';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { TextField } from '@material-ui/core';

export default WithApp(function ModalFilterBPartner(props) {
  const {
    open,
    setOpen,
    cardType,
    entity,
    filterProps,
    setBPartnerSelect,
    extraFields = undefined
  } = props;

  const cardCodeRef = useRef(null);
  const cardNameRef = useRef(null);

  const isCustomer = cardType === 'C' ? true : false;
  const columns = [
    { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
    { Header: 'Código', accessor: 'CardCode', width: 120 },
    {
      Header: `Nombre de ${isCustomer ? 'cliente' : 'proveedor'}`,
      accessor: 'CardName'
    },
    { Header: 'RUC/DNI', accessor: 'LicTradNum', width: 130 },
    // { Header: 'Estado', accessor: 'state', width: 130 },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
  ];

  // const [valueSearch, setValueSearch] = useState({});
  // const handleChange = (e) => {
  //   setValueSearch({
  //     ...valueSearch,
  //     [e.target.name]: e.target.value
  //   });
  // };

  function enter(e) {
    if (e.charCode == 13) {
      search();
    }
  }

  function search() {
    let valueSearch = {};
    if(!!cardCodeRef.current?.value){
      valueSearch.CardCode = cardCodeRef.current.value;
    }
    if(!!cardNameRef.current?.value){
      valueSearch.CardName = cardNameRef.current.value;
    }
    listBParners(valueSearch);
  }

  const [bPartners, setBPartners] = useState([]);

  async function listBParners(search) {
    if (!!filterProps) {
      search = { ...search, ...filterProps, CardType: cardType };
    } else {
      search = { ...search, CardType: cardType };
    }

    for (var clave in search) {
      if (search[clave] == null) {
        delete search[clave]; //eliminamos solo las claves vacias
      }
    }

    let response = await wsFindBy(entity, search);
    if (response.success) setBPartners(response.data);
  }

  const mergeFields = () => {
    let newColums = [...columns];
    if (extraFields) {
      for (let obj of extraFields) {
        newColums.splice(4, 0, obj);
      }
    }
    return newColums;
  };

  useEffect(() => {
    if (open) listBParners();
  }, [open]);

  return (
    <ModalFull
      title={`Filtro de ${isCustomer ? 'clientes' : 'provedores'}`}
      open={open}
      setOpen={() => setOpen(false)}
    >
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={5} lg={3}>
              <TextField
                label="Código"
                fullWidth
                type="text"
                margin="normal"
                name="CardCode"
                defaultValue=""
                // onChange={handleChange}
                inputRef={cardCodeRef}
                onKeyPress={enter}
              />
            </GridItem>
            <GridItem xs={12} sm={5} lg={3}>
              <TextField
                label="Nombre"
                fullWidth
                type="text"
                margin="normal"
                name="CardName"
                defaultValue=""
                inputRef={cardNameRef}
                // onChange={handleChange}
                onKeyPress={enter}
              />
            </GridItem>
            <GridItem xs={6} sm={2}>
              <Button justIcon round color="primary" onClick={search}>
                <Search />
              </Button>
            </GridItem>
          </GridContainer>

          <ReactTable
            key={bPartners}
            defaultWidth={1100}
            exportExcel={false}
            columns={mergeFields()}
            data={bPartners.map((bPartner, i) => {
              const data = {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      size="sm"
                      round
                      color={props.themeContext.buttonColorSuccess}
                      onClick={() => {
                        setBPartnerSelect(bPartner);
                        setOpen(false);
                      }}
                      style={{ marginLeft: '8px' }}
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                CardCode: bPartner.CardCode,
                CardName: bPartner.CardName,
                LicTradNum: bPartner.LicTradNum,
                state: bPartner.frozenFor === 'N' ? 'Activo' : 'Inactivo',
                actions: '',
              };
              if (extraFields) {
                let newObject = data;
                for (let obj of extraFields) {
                  newObject = { ...newObject, [obj.accessor]: bPartner[obj.accessor] };
                }
                return newObject;
              }
              return data;
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
